/**
 * 事件类型
 */
var EVENTTYPES;
(function (EVENTTYPES) {
    EVENTTYPES["INIT"] = "init";
    EVENTTYPES["ERROR"] = "error";
    EVENTTYPES["UNHANDLEDREJECTION"] = "unhandledrejection";
    EVENTTYPES["RESOURCE"] = "resource";
    EVENTTYPES["PERFORMANCE"] = "performance";
    EVENTTYPES["WHITESCREEN"] = "whiteScreen";
    EVENTTYPES["BREABCRUMB"] = "breadcrumb"; // 行为日志
})(EVENTTYPES || (EVENTTYPES = {}));
/**
 * 用户行为
 */
var BREADCRUMBTYPES;
(function (BREADCRUMBTYPES) {
    BREADCRUMBTYPES["ERROR"] = "error";
    BREADCRUMBTYPES["CLICK"] = "click";
    BREADCRUMBTYPES["HISTORY"] = "history";
    BREADCRUMBTYPES["HASHCHANGE"] = "hashchange";
    BREADCRUMBTYPES["UNHANDLEDREJECTION"] = "unhandledrejection";
    BREADCRUMBTYPES["RESOURCE"] = "resource";
    BREADCRUMBTYPES["WHITE"] = "white";
    BREADCRUMBTYPES["CUSTOM"] = "custom";
    BREADCRUMBTYPES["SCROLL"] = "scroll";
    BREADCRUMBTYPES["API"] = "request";
})(BREADCRUMBTYPES || (BREADCRUMBTYPES = {}));
var LIFTCYCLETYPE;
(function (LIFTCYCLETYPE) {
    LIFTCYCLETYPE["BEFORE"] = "mirrorHandlerBefore";
    LIFTCYCLETYPE["AFTER"] = "mirrorHandlerAfter";
})(LIFTCYCLETYPE || (LIFTCYCLETYPE = {}));
var STATUS_CODE;
(function (STATUS_CODE) {
    STATUS_CODE["ERROR"] = "error";
    STATUS_CODE["OK"] = "ok";
})(STATUS_CODE || (STATUS_CODE = {}));
var InitMode;
(function (InitMode) {
    InitMode["AUTO"] = "auto";
    InitMode["DEFAULT"] = "default";
})(InitMode || (InitMode = {}));
var USERLOGTYPE;
(function (USERLOGTYPE) {
    USERLOGTYPE["HISTORY"] = "history";
    USERLOGTYPE["HASH"] = "hash";
    USERLOGTYPE["DOM"] = "dom";
    USERLOGTYPE["JS"] = "js";
    USERLOGTYPE["PROMISE"] = "promise";
    USERLOGTYPE["RESOURCE"] = "resource";
    USERLOGTYPE["WHITE"] = "white";
    USERLOGTYPE["SCROLL"] = "scroll";
    USERLOGTYPE["API"] = "request";
})(USERLOGTYPE || (USERLOGTYPE = {}));
var USERTRACKTYPE;
(function (USERTRACKTYPE) {
    USERTRACKTYPE["LOAD"] = "info-load";
    USERTRACKTYPE["REFRESH"] = "info-refresh";
    USERTRACKTYPE["PAGETABSTATUS"] = "info-visibilitychange";
    USERTRACKTYPE["DEVICE"] = "info-device";
    USERTRACKTYPE["SCROLL"] = "info-scroll";
    USERTRACKTYPE["PAGECLOSE"] = "info-close";
    USERTRACKTYPE["CLICK"] = "info-click";
    USERTRACKTYPE["HISTORY"] = "info-history";
    USERTRACKTYPE["HASHCHANGE"] = "info-hashchange";
    USERTRACKTYPE["APIUNKNOWN"] = "info-request-unknown";
    USERTRACKTYPE["APISUCCESS"] = "success-request";
    USERTRACKTYPE["APIERROR"] = "error-request";
    USERTRACKTYPE["ERROR"] = "error-js";
    USERTRACKTYPE["UNHANDLEDREJECTION"] = "error-unhandledrejection";
    USERTRACKTYPE["RESOURCE"] = "error-resource";
    USERTRACKTYPE["WHITE"] = "error-white";
})(USERTRACKTYPE || (USERTRACKTYPE = {}));
const SIGNMANAGE = {
    TECH_CUSTOM: { isExclusive: 1 },
    TECH_POLYMER: { mirrorPolymer: 3 } // 标识,api聚合上报标识
};

export { BREADCRUMBTYPES, EVENTTYPES, InitMode, LIFTCYCLETYPE, SIGNMANAGE, STATUS_CODE, USERLOGTYPE, USERTRACKTYPE };
